import axios from "axios";
import { path_url } from "../Config/config";

const apiClient = axios.create({
  baseURL: path_url,
  timeout: 120000,
});

// Request Interceptor: Automatically inject the access token if present
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("[API REQUEST ERROR]", error);
    return Promise.reject(error);
  },
);

// Response Interceptor: Manage session expiry (401/403) and normalize errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const errorDataStr = JSON.stringify(error.response?.data || "");
    const isMissingConfig = errorDataStr
      .toLowerCase()
      .includes("configuration not found");

    if (!isMissingConfig) {
      console.group("[API RESPONSE ERROR]");
      console.error("Status:", error.response?.status);
      console.error("Data:", error.response?.data);
      console.error("Message:", error.message);
      console.groupEnd();
    }

    const status = error.response?.status;

    if (status === 401 || status === 403) {
      // Session expired: Clear tokens and redirect to login
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("adminId");

      // Prevent infinite redirect loops if we are already on login page
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;
